import React from 'react';
import { List, Datagrid, TextField, TextInput, Filter, FunctionField, Pagination } from 'react-admin';
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    sanitizeListRestProps,
} from 'react-admin';
import CircleIcon from '@material-ui/icons/FiberManualRecord';


const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        showFilter,
    } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
        </TopToolbar>
    );
};

export const InternetPagination = props => <Pagination rowsPerPageOptions={[1000]} {...props} />;

export const InternetList = props => (
    <List filters={<BuildingFilter />} {...props} actions={<ListActions />} >
        <Datagrid rowClick={(id) => `/buildings/${id}/show`}>
            <TextField source="id" />
            <TextField source="address" label='Dirección' />
            <FunctionField source="green" render={record => <span>{record.green}<CircleIcon style={{ color: 'green' }} /></span>} label='Conectado' />
            <FunctionField source="yellow" render={record => <span>{record.yellow}<CircleIcon style={{ color: 'yellow' }} /></span>} label='Pendiente' />
            <FunctionField source="red" render={record => <span>{record.red}<CircleIcon style={{ color: 'red' }} /></span>} label='Sin conexión' />
            <FunctionField source="black" render={record => <span>{record.black}<CircleIcon style={{ color: 'black' }} /></span>} label='En reparación' />
            <FunctionField source="white" render={record => <span>{record.white}<CircleIcon style={{ color: 'white', stroke: "#000000", strokeWidth: 1 }} /></span>} label='Inactiva' />
        </Datagrid>
    </List>

);
const BuildingFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="q" alwaysOn />
    </Filter>
);
